export default __webpack_public_path__ + "static/media/CACHERULES.c2e522b7.webp";